export const mapTemplateToReadableInfo = (values = {}) => {
  const apps = [];

  (values.featureSuggestions || []).forEach(feature => {
    const appInstallation = `${feature?.appInstallation.id}_${feature?.appInstallation.tag}`;
    const foundApp = apps.find(app => app?.appInstallation === appInstallation);
    if (foundApp) {
      foundApp.features.push({
        id: feature.communityAppFeature?.appInstallationFeature.tag,
        name: feature.communityAppFeature?.appInstallationFeature.name,
        roles: (feature.featureRoleSuggestions || []).map(frs => ({
          id: frs.appInstallationFeatureRole?.id,
          name: frs.communityAppFeatureRole?.appInstallationFeatureRole?.name,
        })),
      });
    } else {
      apps.push({
        id: appInstallation,
        name: feature.appInstallation?.name,
        features: [
          {
            id: feature.communityAppFeature?.appInstallationFeature?.tag,
            name: feature.communityAppFeature?.appInstallationFeature?.name,
            roles: (feature.featureRoleSuggestions || []).map(frs => ({
              id: frs.appInstallationFeatureRole?.id,
              name: frs.communityAppFeatureRole?.appInstallationFeatureRole?.name,
            })),
          },
        ],
      });
    }
  });

  const communityRoles = (values.communityRoleSuggestions || []).map(
    crs => crs.communityRole?.alias || crs.communityRole?.name
  );

  return { apps, communityRoles };
};
